import { Pipe, PipeTransform } from "@angular/core";
import { ApplicationUtilsService } from "@util-services";

@Pipe({
  name: "promptvalue",
  standalone: false,
})
export class PromptValuePipe implements PipeTransform {
  constructor(public appController: ApplicationUtilsService) {}
  async transform(
    value: string,
    hoofdletter: boolean = false
  ): Promise<string> {
    if (!value) return value;
    let prompt = await this.appController.getPrompt(value);

    if (hoofdletter && prompt != null && prompt.length > 0) {
      prompt = prompt.charAt(0).toUpperCase() + prompt.slice(1);
    }

    let start = prompt.indexOf("<<");
    let end = prompt.indexOf(">>");

    if (start > -1 && end > -1 && start < end) {
      let waardeParameter = this.appController.getSectorParameter(
        prompt.substring(start + 2, end)
      );
      prompt =
        prompt.substring(0, start) +
        waardeParameter +
        prompt.substring(end + 2);
    }

    return prompt;
  }
}
